import mapList from './mapList';

const demoStrategies = [
  {
    id: 'hp-summit-fast-break',
    name: 'Summit Hardpoint — Fast Break',
    mode: 'hardpoint',
    map: 'summit',
    summary: 'Aggressive opening that breaks P1 fast and sets spawns for P2.',
    highlights: ['Double-nade top control', 'SMG pinch from lower', 'Anchor rotates early for P2'],
    steps: [
      {
        title: 'Off the break',
        description: 'Crash P1 from top control and lower while trophies cover lane crosses.',
        players: [
          { id: 'hp-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 22, y: 70 },
          { id: 'hp-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 36, y: 58 },
          { id: 'hp-c', label: 'C', role: 'Flex', color: '#ffd166', x: 48, y: 52 },
          { id: 'hp-d', label: 'D', role: 'AR', color: '#f78c6b', x: 58, y: 40 },
          { id: 'hp-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 18, y: 32 },
        ],
        utilities: [
          { id: 'hp-u1', type: 'trophy', x: 42, y: 54 },
          { id: 'hp-u2', type: 'smoke', x: 52, y: 44 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 22, y: 70 }, { x: 36, y: 64 }, { x: 44, y: 54 }] },
          { color: '#b6f09c', width: 3, opacity: 0.8, points: [{ x: 36, y: 58 }, { x: 44, y: 52 }, { x: 52, y: 48 }] },
          { color: '#f78c6b', width: 3, opacity: 0.8, points: [{ x: 58, y: 40 }, { x: 52, y: 46 }] },
        ],
      },
      {
        title: 'Stabilize P1',
        description: 'Hold crosses, watch pinch, trophy replaces at 30s.',
        players: [
          { id: 'hp-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 34, y: 60 },
          { id: 'hp-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 44, y: 46 },
          { id: 'hp-c', label: 'C', role: 'Flex', color: '#ffd166', x: 56, y: 42 },
          { id: 'hp-d', label: 'D', role: 'AR', color: '#f78c6b', x: 64, y: 36 },
          { id: 'hp-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 30, y: 28 },
        ],
        utilities: [
          { id: 'hp-u3', type: 'trophy', x: 48, y: 50 },
          { id: 'hp-u4', type: 'smoke', x: 60, y: 38 },
        ],
        paths: [
          { color: '#ffd166', width: 3, opacity: 0.8, points: [{ x: 56, y: 42 }, { x: 62, y: 40 }] },
        ],
      },
      {
        title: 'Rotate early P2',
        description: 'Anchor slides to P2, flex cuts mid, SMG pinches back alley.',
        players: [
          { id: 'hp-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 40, y: 48 },
          { id: 'hp-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 52, y: 40 },
          { id: 'hp-c', label: 'C', role: 'Flex', color: '#ffd166', x: 60, y: 36 },
          { id: 'hp-d', label: 'D', role: 'AR', color: '#f78c6b', x: 72, y: 30 },
          { id: 'hp-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 78, y: 26 },
        ],
        utilities: [
          { id: 'hp-u5', type: 'trophy', x: 70, y: 32 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 40, y: 48 }, { x: 52, y: 44 }, { x: 64, y: 38 }] },
          { color: '#c084fc', width: 3, opacity: 0.8, points: [{ x: 30, y: 28 }, { x: 44, y: 30 }, { x: 60, y: 28 }, { x: 78, y: 26 }] },
        ],
      },
    ],
  },
  {
    id: 'snd-standoff-split-hit',
    name: 'Standoff S&D — Split 3/2',
    mode: 'snd',
    map: 'standoff',
    summary: 'Default info grab into fast B with late mid pinch.',
    highlights: ['Info A alley', 'Double nade statue', 'Late mid pinch'],
    steps: [
      {
        title: 'Default info',
        description: 'Grab info top blue and mid statue while bomb edges up B long.',
        players: [
          { id: 'sd-a', label: 'A', role: 'Bomb', color: '#6dd3ff', x: 18, y: 62 },
          { id: 'sd-b', label: 'B', role: 'AR', color: '#b6f09c', x: 32, y: 52 },
          { id: 'sd-c', label: 'C', role: 'Flex', color: '#ffd166', x: 46, y: 46 },
          { id: 'sd-d', label: 'D', role: 'Entry', color: '#f78c6b', x: 60, y: 52 },
          { id: 'sd-e', label: 'E', role: 'Lurk', color: '#c084fc', x: 48, y: 34 },
        ],
        utilities: [
          { id: 'sd-u1', type: 'grenade', x: 42, y: 48 },
          { id: 'sd-u2', type: 'trophy', x: 20, y: 60 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 18, y: 62 }, { x: 28, y: 58 }, { x: 36, y: 54 }] },
          { color: '#f78c6b', width: 3, opacity: 0.8, points: [{ x: 60, y: 52 }, { x: 56, y: 46 }, { x: 52, y: 40 }] },
        ],
      },
      {
        title: 'Commit B',
        description: 'Double nade statue, smoke boxes, pinch mid with lurk timing.',
        players: [
          { id: 'sd-a', label: 'A', role: 'Bomb', color: '#6dd3ff', x: 26, y: 56 },
          { id: 'sd-b', label: 'B', role: 'AR', color: '#b6f09c', x: 36, y: 46 },
          { id: 'sd-c', label: 'C', role: 'Flex', color: '#ffd166', x: 50, y: 42 },
          { id: 'sd-d', label: 'D', role: 'Entry', color: '#f78c6b', x: 62, y: 44 },
          { id: 'sd-e', label: 'E', role: 'Lurk', color: '#c084fc', x: 54, y: 30 },
        ],
        utilities: [
          { id: 'sd-u3', type: 'smoke', x: 44, y: 44 },
          { id: 'sd-u4', type: 'smoke', x: 60, y: 42 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 26, y: 56 }, { x: 32, y: 52 }, { x: 40, y: 48 }] },
          { color: '#c084fc', width: 3, opacity: 0.8, points: [{ x: 54, y: 30 }, { x: 50, y: 36 }, { x: 48, y: 42 }] },
        ],
      },
      {
        title: 'Plant & post',
        description: 'Plant safe side, set crossfires with one late flank watch.',
        players: [
          { id: 'sd-a', label: 'A', role: 'Bomb', color: '#6dd3ff', x: 38, y: 48 },
          { id: 'sd-b', label: 'B', role: 'AR', color: '#b6f09c', x: 44, y: 40 },
          { id: 'sd-c', label: 'C', role: 'Flex', color: '#ffd166', x: 56, y: 38 },
          { id: 'sd-d', label: 'D', role: 'Entry', color: '#f78c6b', x: 62, y: 46 },
          { id: 'sd-e', label: 'E', role: 'Lurk', color: '#c084fc', x: 68, y: 34 },
        ],
        utilities: [
          { id: 'sd-u5', type: 'trophy', x: 40, y: 46 },
        ],
        paths: [
          { color: '#b6f09c', width: 3, opacity: 0.8, points: [{ x: 44, y: 40 }, { x: 52, y: 38 }, { x: 60, y: 40 }] },
        ],
      },
    ],
  },
  {
    id: 'ctl-raid-a-stack',
    name: 'Raid Control — A Stack',
    mode: 'control',
    map: 'raid',
    summary: 'Front-load lives to cap A fast, then re-hit mid for B control.',
    highlights: ['2-stack zig push', 'Early lives advantage', 'Mid re-hit timing'],
    steps: [
      {
        title: 'Hit A',
        description: 'Three push zig, two watch mid cut; smoke ring to block sight.',
        players: [
          { id: 'ct-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 26, y: 64 },
          { id: 'ct-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 34, y: 58 },
          { id: 'ct-c', label: 'C', role: 'Flex', color: '#ffd166', x: 44, y: 50 },
          { id: 'ct-d', label: 'D', role: 'AR', color: '#f78c6b', x: 52, y: 44 },
          { id: 'ct-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 40, y: 30 },
        ],
        utilities: [
          { id: 'ct-u1', type: 'smoke', x: 46, y: 46 },
          { id: 'ct-u2', type: 'trophy', x: 36, y: 56 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 26, y: 64 }, { x: 34, y: 58 }, { x: 42, y: 52 }] },
          { color: '#c084fc', width: 3, opacity: 0.8, points: [{ x: 40, y: 30 }, { x: 48, y: 34 }, { x: 52, y: 40 }] },
        ],
      },
      {
        title: 'Secure ticks',
        description: 'Two stack point, others watch flanks and mid pinch.',
        players: [
          { id: 'ct-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 36, y: 54 },
          { id: 'ct-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 42, y: 50 },
          { id: 'ct-c', label: 'C', role: 'Flex', color: '#ffd166', x: 52, y: 44 },
          { id: 'ct-d', label: 'D', role: 'AR', color: '#f78c6b', x: 60, y: 40 },
          { id: 'ct-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 48, y: 32 },
        ],
        utilities: [
          { id: 'ct-u3', type: 'trophy', x: 44, y: 48 },
        ],
        paths: [
          { color: '#ffd166', width: 3, opacity: 0.8, points: [{ x: 52, y: 44 }, { x: 60, y: 42 }] },
        ],
      },
      {
        title: 'Re-hit mid for B',
        description: 'Rotate through mid cut, keep one watching A pinch.',
        players: [
          { id: 'ct-a', label: 'A', role: 'Entry', color: '#6dd3ff', x: 46, y: 46 },
          { id: 'ct-b', label: 'B', role: 'Flex', color: '#b6f09c', x: 56, y: 42 },
          { id: 'ct-c', label: 'C', role: 'Flex', color: '#ffd166', x: 64, y: 36 },
          { id: 'ct-d', label: 'D', role: 'AR', color: '#f78c6b', x: 70, y: 30 },
          { id: 'ct-e', label: 'E', role: 'Anchor', color: '#c084fc', x: 54, y: 34 },
        ],
        utilities: [
          { id: 'ct-u4', type: 'smoke', x: 60, y: 38 },
        ],
        paths: [
          { color: '#6dd3ff', width: 3, opacity: 0.8, points: [{ x: 46, y: 46 }, { x: 54, y: 42 }, { x: 64, y: 38 }] },
        ],
      },
    ],
  },
];

export const getMapMeta = (mode, mapName) => {
  const maps = mapList[mode] || [];
  return maps.find((m) => m.name.toLowerCase() === mapName.toLowerCase());
};

export const getDemoStrategy = (demoId) =>
  demoStrategies.find((s) => s.id === demoId);

export default demoStrategies;
